export default __webpack_public_path__ + "e7f5b0721313073de1bcb04b01c7c67b.png";